<template>
    <div class="body">
        <div class="search">
            <p class="h1">查外贸,就用海查查</p>
            <p class="h2">查外贸 ｜ 查客户 ｜ 查企业</p>
            <div class="searchinput">
                <input class="sousuo" type="text" placeholder="请输入您搜索的关键词" v-model="searchVal" />
                <button @click="search(searchVal)">搜索</button>
            </div>
        </div>
        <div class="screen">
            <div class="screen_in">
                <div>
                    <p>品名</p>
                    <el-select v-model="proFirst" placeholder="请选择一级条目" filterable class="select" @change="changeFirst">
                        <el-option v-for="item in options" :key="item.hsClassifyCode" :label="item.hsClassifyName" :value="item.hsClassifyCode">
                        </el-option>
                    </el-select>
                    <el-select v-model="proSecond" placeholder="请选择二级条目" filterable :disabled="proSecondDis" @change="changeSecond">
                        <el-option v-for="item in proSecondList" :key="item.value" :label="item.hsSectionName" :value="item.hsSectionCode">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <p>类型</p>
                    <el-select v-model="proType" placeholder="请选择(进/出)口类型" @change="changeType">
                        <el-option v-for="item in proTypeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
                    </el-select>
                </div>
                <div>
                    <p>报关港</p>
                    <el-select v-model="proPort" filterable placeholder="请选择报关港" @change="changePort">
                        <el-option v-for="item in proPortList" :key="item.id" :label="item.portName" :value="item.portName"></el-option>
                    </el-select>
                </div>
                <div>
                    <p>出口国</p>
                    <el-select v-model="proCountry" filterable placeholder="请选择出口国家" @change="changeCountry">
                        <el-option v-for="item in proCountryList" :key="item.index" :label="item.cn" :value="item.cn"></el-option>
                    </el-select>
                </div>
                <div>
                    <button @click="reset">重置</button>
                </div>
            </div>
        </div>
        <div class="list_list">
            <div class="list_in" v-loading="loading && page==1" v-if="!noData">
                <div id="apperweima" v-show="ewm == 1" :class="[{ apperweima: ewm == 1 }]">
                    <img src="http://www.haichacha.net/wechat.jpg" alt />
                    <p>
                        下载
                        <a href="javascript:;">海查查app</a>，更多数据查阅
                    </p>
                </div>
                <div v-for="(item, index) in dataList" :key="item.id">
                    <div class="left">
                        <i v-if="item.isNew == 1">NEW</i>
                        <p class="h1">{{ item.enterpriseName }}</p>
                        <div class="flag">
                            <span class="chukou" v-if="item.isExport == 1">出口</span>
                            <span class="chukou jinkou" v-if="item.isImport == 1">进口</span>
                            <span class="fl1" v-if="item.recentTrading == 1">低贸易量</span>
                            <span class="fl2" v-if="item.recentTrading == 2">中贸易量</span>
                            <span class="fl3" v-if="item.recentTrading == 3">高贸易量</span>
                        </div>
                        <p class="h2 twolinehidden">{{ item.exportCountry }}</p>
                        <p class="h3 threelinehidden">{{ item.productName }}</p>
                    </div>
                    <div class="right">
                        <a href="javascript:;" @click="todetail(item.id,index)">查看详情</a>
                        <span v-if="item.isCollect == 1" @click="cancelFavor(item.id, index, 0)"><img src="@/assets/img/star.png" alt="" />已关注</span>
                        <span v-if="item.isCollect == 0" @click="favor(item.id, index, 1)"><img src="@/assets/img/star_empty.png" alt="" />关注</span>
                    </div>
                </div>
            </div>
            <div class="isshaixuan" v-else>
                <img src="@/assets/img/zwnr.png" alt />
            </div>
          <div class="custom-pagination" v-if="!noData && (dataList.length > 0 || page > 1)">
            <button
              class="pag-btn"
              :disabled="page <= 1"
              @click="handlePageChange(page - 1)"
            >
              上一页
            </button>
            <span class="pag-text">第 {{ page }} 页</span>
            <button
              class="pag-btn"
              :disabled="isLastPage"
              @click="handlePageChange(page + 1)"
            >
              下一页
            </button>
            <div class="pag-jumper">
              <span>前往第</span>
              <input
                type="number"
                v-model.number="jumpInput"
                @keyup.enter="doJump"
                min="1"
              />
              <span>页</span>
              <button class="pag-go" @click="doJump">确定</button>
            </div>
          </div>

        </div>
        <popup ref="popup"></popup>
        <conversation></conversation>
    </div>
</template>

<script>
import Conversation from "@/components/Conversation";
import country from "@/assets/js/country.js";
import popup from "@/components/Popup";
import Utils from '@/assets/js/util.js';
import {
    Loading,
    MessageBox
} from "element-ui";
import {
    mapGetters
} from "vuex";
export default {
    components: {
        Conversation,
        popup,
    },
    computed: {
        ...mapGetters({
            userInfo: "getUser", oneimpor: "getOne",
        })
    },
    data() {
        return {
            noData: false,
            loading: true,
            isLastPage: false, // 新增：标记是否最后一页
            jumpInput: '',     // 新增：跳转输入框绑定
            searchVal: "",
            ewm: 0,
            options: [{
                hsClassifyName: "不限",
                hsClassifyCode: "",
            },],
            proSecondList: [],
            proSecondDis: true,
            proTypeList: [{
                value: "不限",
                id: "",
            },
            {
                value: "进口",
                id: "1",
            },
            {
                value: "出口",
                id: "2",
            },
            ],
            proPortList: [{
                id: "000",
                portName: "全部",
            },],
            proCountryList: country,
            proFirst: "",
            proSecond: "",
            proType: "",
            proPort: "",
            proCountry: "",
            page: 1,
            limit: 10,         // 确保这里有定义每页数量
            dataList: [],
            isExport: "",
            isImport: "",
            scrollpos: 0,
        };
    },
    watch: {
        $route(to, from) {
            if (from.path == '/login') {
                this.reset()
            }
        }
    },
    mounted() {
        this.getoneclass();
        this.getDataList();
        var that = this;
        Utils.$on('getCollect', function (data) {
            that.changeCollect(data);
        })
    },
    activated() {
        this.showPoput()
    },
    methods: {
        showPoput() {
            if (this.userInfo.tryCount == 10 && this.userInfo.role == 1 && !this.oneimpor) {
                this.$refs.popup.isvipshow(1);
                this.$store.commit("setOne", 1);
            }
        },
        changeCollect(data) {
            this.dataList[data.index].isCollect = data.isCollect;
        },
        search(val) {
            if (val == "") {
                this.$message.error("请输入关键字");
            } else {
                this.dataList = [];
                this.page = 1;
                this.getDataList();
            }
        },
      getDataList() {
        this.loading = true;
        let json = {
          customsPort: this.proPort == "全部" ? '' : this.proPort,
          searchContent: this.searchVal,
          goalCountry: this.proCountry == "全部" ? "" : this.proCountry,
          importExportType: this.proType,
          productName: this.proSecond,
          page: this.page,
          limit: this.limit,
          order: "desc",
          sidx: "he.recent_trading",
        };

        this.$http.get("/app/enterprise/list", { params: json })
          .then((res) => {
            this.loading = false;
            if (res.data.code == 0) {
              const list = res.data.data.list || [];

              // 1. 直接替换数据，不再 push
              this.dataList = list;

              // 2. 判断无数据情况
              if (this.page === 1 && list.length === 0) {
                this.noData = true;
                this.isLastPage = true;
                return;
              } else {
                this.noData = false;
              }

              // 3. 核心判断：如果返回的数据少于每页限制，说明没有下一页了
              if (list.length < this.limit) {
                this.isLastPage = true;
              } else {
                this.isLastPage = false;
              }
            } else {
              this.dataList = [];
              this.noData = true;
            }
          })
          .catch(() => {
            this.loading = false;
            this.noData = true;
          });
      },
      // 处理上一页/下一页点击
      handlePageChange(newPage) {
        if (newPage < 1) return;
        if (newPage === this.page) return;
        if (newPage > this.page && this.isLastPage) return;

        this.page = newPage;
        this.jumpInput = '';

        // 【修改点】使用 $nextTick 确保 DOM 更新后再滚动
        this.$nextTick(() => {
          // 兼容不同浏览器的滚动根元素
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;

          // 如果上述方法无效，尝试使用平滑滚动 API 强制触发
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto' // 如果需要平滑效果可改为 'smooth'，但分页通常建议 'auto' 瞬间跳转
          });
        });

        this.getDataList();
      },

// 处理跳转
      doJump() {
        if (!this.jumpInput || this.jumpInput < 1) {
          this.$message.warning('请输入有效页码');
          this.jumpInput = this.page;
          return;
        }
        if (this.jumpInput === this.page) return;

        this.page = this.jumpInput;

        // 【修改点】同样使用 $nextTick
        this.$nextTick(() => {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        });

        this.getDataList();
      },
        getoneclass() {
            this.$http.get("app/common/productNameFirstList").then((res) => {
                //品名一级分类
                if (res.data.code == 0) {
                    this.options.push(...res.data.data);
                    this.proSecond = "";
                    this.proSecondList = [];
                }
            });
            this.$http.get("app/common/customsPortList").then((res) => {
                //获取报关港
                if (res.data.code == 0) {
                    this.proPortList.push(...res.data.data);
                }
            });
        },
        changeFirst() {
            if (this.proFirst == "") {
                this.proSecond = "";
                this.dataList = [];
                this.proSecondDis = true;
                this.page = 1;
                this.noData = false;
                this.getDataList();
            } else {
                this.proSecond = "";
                this.proSecondList = [];
                this.$http
                    .get("app/common/productNameSecondList/" + this.proFirst)
                    .then((res) => {
                        if (res.data.code == 0) {
                            this.proSecondList = res.data.data;
                            this.proSecondDis = false;
                        }
                    });
            }
        },
        changeSecond() {
            this.dataList = [];
            this.page = 1;
            this.noData = false;
            this.getDataList();
        },
        changeType() {
            if (this.proType == 1) {
                this.isImport = 1;
                this.isExport = 0;
            } else {
                this.isImport = 0;
                this.isExport = 1;
            }
            this.page = 1;
            this.dataList = [];
            this.noData = false;
            this.getDataList();
        },
        changePort() {
            this.dataList = [];
            this.page = 1;
            this.noData = false;
            this.getDataList();
        },
        changeCountry() {
            this.dataList = [];
            this.page = 1;
            this.noData = false;
            this.getDataList();
        },
        reset() {
            this.searchVal = "";
            this.proFirst = "";
            this.proSecond = "";
            this.proType = "";
            this.proPort = "";
            this.proCountry = "";
            this.proSecondList = [];
            this.proSecondDis = true;
            this.page = 1;
            this.isLastPage = false; // 新增
            this.jumpInput = '';     // 新增
            this.dataList = [];
            this.noData = false;
            this.getDataList();

        },
        todetail(id, index) {
            this.$http.get("app/enterprise/info/" + id).then((res) => {
                if (res.data.code == 1) {
                    //您的试用次数已用完
                    this.$refs.popup.isvipshow(2);
                } else if (res.data.code == 0) {
                    this.$router.push({
                        path: "/home/detail",
                        query: {
                            id: id,
                            index: index
                        },
                    });
                }
            });
        },
        favor(id, index, state) {
            this.$http.get("/app/enterprise/follow/" + id).then((res) => {
                console.log(res);
                if (res.status == 200) {
                    if (state == 0) {
                        this.$set(this.dataList[index], "isCollect", 0);
                    } else {
                        this.$set(this.dataList[index], "isCollect", 1);
                    }
                }
            });
        },
        cancelFavor(id, index, state) {
            MessageBox.confirm("是否取消关注?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(() => {
                    this.favor(id, index, state);
                })
                .catch(() => { });
        },
    },
    deactivated() {
    },
};
</script>

<style lang="less" scoped>
.next-load::after {
    background-color: #fff;
}
.next-load span {
    background: #fff;
}
.search {
    width: 100%;
    height: 220px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url("../../assets/img/data.jpg") no-repeat center center;
    background-size: cover;

    p {
        width: 100%;
        text-align: center;
    }

    .h1 {
        font-size: 33px;
        letter-spacing: 5px;
        color: #ffffff;
        box-shadow: 3px 1px 21px 0px rgba(42, 127, 243, 0.53);
    }

    .h2 {
        font-size: 14px;
        font-weight: bold;
        letter-spacing: 2px;
        color: #ffffff;
        margin: 15px 0;
    }

    .searchinput {
        width: 840px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 10px;
        overflow: hidden;

        input {
            width: 700px;
            height: 60px;
            padding-left: 66px;
            background: url("../../assets/img/search.png") no-repeat 24px center;
            background-color: #fff;
            font-size: 18px;
            color: #333333;
        }

        input::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #a4a4a4;
        }

        input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #a4a4a4;
        }

        input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #a4a4a4;
        }

        input::-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: #a4a4a4;
        }

        button {
            width: 140px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            font-size: 20px;
            font-weight: bold;
            color: #fff;
            letter-spacing: 10px;
            background-image: linear-gradient(0deg, #ff942c 0%, #ffb534 100%),
                linear-gradient(#ffa11b, #ffa11b);
            background-blend-mode: normal, normal;
            cursor: pointer;
        }
    }
}

.screen {
    width: 100%;
    background-color: #fff !important;
    box-shadow: 3px 1px 59px 0px rgba(5, 53, 108, 0.11);

    .screen_in {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        padding: 30px 0;
        color: #333333;

        > div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 10px 0;

            p {
                width: 80px;
                text-align: right;
                font-size: 16px;
                font-weight: bold;
                color: #414141;
            }

            .el-select {
                width: 300px;
                margin-left: 20px;
            }

            button {
                width: 90px;
                height: 40px;
                background-color: #3779ff;
                border-radius: 5px;
                font-size: 16px;
                font-weight: bold;
                color: #ffffff;
                text-align: center;
                line-height: 40px;
                margin-left: 100px;
                cursor: pointer;
            }
        }
    }

    input {
        color: #333333 !important;
    }
}

.list_list {
    width: 1200px;
    margin: 0 auto;

    .list_in {
        width: 1200px;
        min-height: 300px;
        position: relative;

        #apperweima {
            width: 200px;
            height: 240px;
            background-color: #fff;
            padding: 0;
            position: absolute;
            right: -220px;
            top: 50px;
            box-shadow: 3px 1px 9px 0px rgba(5, 53, 108, 0.11);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            img {
                width: 85%;
            }

            p {
                font-size: 12px;
                color: #464646;
                padding-top: 12px;

                a {
                    color: #004ecf;
                }
            }
        }

        .apperweima {
            position: fixed !important;
            top: 20px !important;
            right: 252px !important;
        }

        > div {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 34px 0;
            border-bottom: 1px solid #ebebeb;

            &:hover {
                background-color: #f8f8f8;
                border-bottom: 1px solid #fff;

                a {
                    background: none;
                    background-image: linear-gradient(
                            0deg,
                            #0063dd 0%,
                            #0072ff 100%
                        ),
                        linear-gradient(#edf5ff, #edf5ff);
                    background-blend-mode: normal, normal;
                    color: #fff !important;
                }
            }

            &:last-child {
                border: 0;

                &:hover {
                    border: 0;
                }
            }

            .left {
                width: 960px;
                position: relative;
                padding-left: 50px;
                box-sizing: border-box;

                i {
                    display: block;
                    width: 40px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    font-size: 12px;
                    background-color: #ff7070;
                    position: absolute;
                    top: 0;
                    left: 0px;
                    color: #fff;
                    border-radius: 10px 10px 10px 0;
                }

                .h1 {
                    width: 100%;
                    font-size: 22px;
                    font-weight: bold;
                    color: #4a4a4a;
                }

                .flag {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-top: 16px;

                    span {
                        color: #fff;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 6px;
                    }

                    .chukou {
                        width: 60px;
                        height: 30px;
                        background-color: #e6edfe;
                        color: #2865ff;
                        margin-right: 10px;
                    }

                    .jinkou {
                        background: #e5fbed;
                        color: #4fc478;
                    }

                    span:last-child {
                        width: 100px;
                        height: 30px;
                        padding-left: 15px;
                    }

                    .fl1 {
                        background: url("../../assets/img/hot.png") #648fff
                            no-repeat 10px center;
                        background-size: 15px 15px;
                    }

                    .fl2 {
                        background: url("../../assets/img/hot.png") #ff9564
                            no-repeat 10px center;
                        background-size: 15px 15px;
                    }

                    .fl3 {
                        background: url("../../assets/img/hot.png") #ff7070
                            no-repeat 10px center;
                        background-size: 15px 15px;
                    }
                }

                .h2 {
                    font-size: 14px;
                    color: #909090;
                    margin-top: 20px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }

                .h3 {
                    font-size: 14px;
                    color: #989898;
                    margin-top: 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 3;

                    s {
                        font-weight: bold;
                        color: #0058f8;
                    }
                }
            }

            .right {
                margin-right: 50px;

                a {
                    display: block;
                    width: 150px;
                    height: 50px;
                    background-color: #edf5ff;
                    border-radius: 5px;
                    font-size: 18px;
                    font-weight: bold;
                    color: #0066e5;
                    text-align: center;
                    line-height: 50px;

                    &:hover {
                        background: none;
                        background-image: linear-gradient(
                                0deg,
                                #0063dd 0%,
                                #0072ff 100%
                            ),
                            linear-gradient(#edf5ff, #edf5ff);
                        background-blend-mode: normal, normal;
                        color: #fff;
                    }
                }

                span {
                    cursor: pointer;
                    margin-top: 11px;
                    display: block;
                    text-align: center;

                    img {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 5px;
                        margin-top: -3px;
                    }
                }
            }
        }
    }

    .loading {
        width: 100%;
        height: 60px;
        text-align: center;
        line-height: 60px;
        font-size: 14px;
        color: #666;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
            font-size: 22px;
            margin-right: 10px;
        }
    }

    .isshaixuan {
        width: 1200px;
        margin: 0 auto;
        padding: 50px 0;

        // background-color: red;
        img {
            max-width: 600px;
            display: block;
            margin: 0 auto;
        }
    }
}

.isvip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);

    .bg {
        width: 402px;
        height: 408px;
        overflow: hidden;

        .close {
            float: right;
        }

        .show {
            margin-top: 38px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;

            .img1 {
                margin: 16px auto 20px;
            }

            .h1 {
                font-size: 26px;
                font-weight: 600;
                color: #483314;
                padding-bottom: 10px;
            }

            .h2 {
                font-size: 16px;
                color: #85593e;
            }

            .tq {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 210px;

                p {
                    font-size: 14px;
                    color: #85593e;
                    padding-left: 10px;
                }
            }

            .tq1 {
                margin-top: 36px;
            }

            .tq2 {
                margin-top: 18px;
            }

            .start {
                margin: 70px 0 0;
                width: 257px;
                height: 48px;
                background-color: #f6d6b0;
                border-radius: 23px;
                display: block;
                font-size: 20px;
                font-weight: 600;
                color: #634824;
                text-align: center;
                line-height: 48px;
            }
        }

        .show1 {
            width: 373px;
            height: 363px;
            background: url("../../assets/img/show1.png") no-repeat center
                center;
            background-size: cover;
        }

        .show2 {
            width: 352px;
            height: 369px;
            background: url("../../assets/img/show2.png") no-repeat center
                center;
            background-size: cover;
            border-radius: 20px;
            overflow: hidden;

            .h1 {
                color: #ffffff;
                margin-top: 44px;
            }

            .h2 {
                color: #ffffff;
            }

            .wx {
                width: 120px;
                margin-top: 50px;
            }

            .red {
                font-size: 18px;
                font-weight: 600;
                color: #ff4e00;
                padding: 10px 0;
            }

            .h5 {
                font-size: 14px;
                // line-height: 22px;
                letter-spacing: 1px;
                color: #999999;
            }
        }
    }
}
.custom-pagination {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  padding-bottom: 40px;
  font-size: 14px;
  color: #606266;

  .pag-btn {
    padding: 8px 16px;
    border: 1px solid #dcdfe6;
    background: #fff;
    border-radius: 4px;
    cursor: pointer;
    color: #606266;
    transition: all 0.3s;

    &:hover:not(:disabled) {
      color: #3779ff;
      border-color: #3779ff;
    }

    &:disabled {
      color: #c0c4cc;
      background: #f5f7fa;
      border-color: #e4e7ed;
      cursor: not-allowed;
    }
  }

  .pag-text {
    margin: 0 20px;
    font-weight: bold;
    color: #3779ff;
    font-size: 16px;
  }

  .pag-jumper {
    margin-left: 30px;
    display: flex;
    align-items: center;

    span {
      margin: 0 5px;
      color: #909399;
    }

    input {
      width: 50px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      text-align: center;
      outline: none;
      &:focus {
        border-color: #3779ff;
      }
    }

    .pag-go {
      margin-left: 8px;
      padding: 6px 12px;
      background: #3779ff;
      color: #fff;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
